import { action } from 'easy-peasy';

const tokenModel = {
	token: '',
	validToken: true,
	isSpecial: false,

	brandingType: false,
	// reportMode: computed(state => state.report),

	setToken: action((state, token) => {
		state.token = token;
	}),
	setValidToken: action((state, validToken) => {
		state.validToken = validToken;
	}),
	setIsSpecial: action((state, isSpecial) => {
		state.isSpecial = isSpecial;
	}),
	setBrandingType: action((state, brandingType) => {
		state.brandingType = brandingType;
	}),
};

export default tokenModel;
